import styles from './styles.module.scss';

type Props = {
  readCount: number;
  totalCount: number;
  ratePercent: number;
};

/**
 * 閲覧率カード
 * 閲覧率（%）・既読数・母数をプログレスバーとともに表示する
 */
export const ViewRateCard: React.FC<Props> = ({ readCount, totalCount, ratePercent }) => (
  <div className={styles.root}>
    <div className={styles.header}>
      <p className={styles.label}>閲覧率</p>
      <div className={styles.stats}>
        <p className={styles.rate}>{ratePercent}%</p>
        <p className={styles.detail}>
          {readCount} / {totalCount}人
        </p>
      </div>
    </div>
    <div className={styles.progressBar}>
      <div className={styles.progressFill} style={{ width: `${ratePercent}%` }} />
    </div>
  </div>
);
